import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useRef, useEffect, useState } from "react";
export default (function (Component) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "span";
  return function (props) {
    var container = useRef(null);
    var component = useRef(null);

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        mounted = _useState2[0],
        setMount = _useState2[1];

    useEffect(function () {
      var eventRe = /on([A-Z]{1,}[a-zA-Z]*)/;
      var watchRe = /watch([A-Z]{1,}[a-zA-Z]*)/;
      component.current = new Component({
        target: container.current,
        props: props
      });
      var watchers = [];

      for (var key in props) {
        var eventMatch = key.match(eventRe);
        var watchMatch = key.match(watchRe);

        if (eventMatch && typeof props[key] === "function") {
          component.current.$on("".concat(eventMatch[1][0].toLowerCase()).concat(eventMatch[1].slice(1)), props[key]);
        }

        if (watchMatch && typeof props[key] === "function") {
          watchers.push(["".concat(watchMatch[1][0].toLowerCase()).concat(watchMatch[1].slice(1)), props[key]]);
        }
      }

      if (watchers.length) {
        var update = component.current.$$.update;

        component.current.$$.update = function () {
          watchers.forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                name = _ref2[0],
                callback = _ref2[1];

            callback(component.current.$$.ctx[name]);
          });
          update.apply(null, arguments);
        };
      }

      return function () {
        component.current.$destroy();
      };
    }, []);
    useEffect(function () {
      if (!mounted) {
        setMount(true);
        return;
      }

      component.current.$set(props);
    }, [props]);
    return React.createElement(tag, {
      ref: container,
      style: style
    });
  };
});